import React from "react";
import InformTable from "../Components/InformTable";
import { HistoryAction } from "../HistoryActionModel";
import { buildValuesTableData, buildDateTableData } from "../utils/historyActionHelpers";

const formatValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    return String(value);
};

export const ProjectCreated: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const general = buildValuesTableData(action.Changes, "new", formatValue);
    const dates = buildDateTableData(action.Changes, "new");

    return (
        <div className="inform_panel">
            <InformTable data={general} label="General" />
            {dates.length > 0 && <InformTable data={dates} label="Date" />}
        </div>
    );
};
